module.exports = __webpack_public_path__ + "img/baner_lp.fc2d23d0.jpg";